import { http } from "@/http";

const BASE_URL = "/api/v1/admin/home/section";

export default {
  list() {
    return http.get(BASE_URL);
  },
  get(id) {
    return http.get(`${BASE_URL}/${id}`);
  },
  create(payload) {
    return http.post(BASE_URL, payload);
  },
  update(id, payload) {
    return http.put(`${BASE_URL}/${id}`, payload);
  },
  delete(id) {
    return http.delete(`${BASE_URL}/${id}`);
  },
  reorder(sectionIds) {
    return http.put(`${BASE_URL}/reorder`, { sectionIds });
  },
  toggleVisibility(id, isVisible) {
    return http.put(`${BASE_URL}/${id}/visibility`, null, {
      params: {
        isVisible,
      },
    });
  },
};
